/* eslint-disable no-nested-ternary */
import React from "react";

import { TableCell as MaterialTableCell, TableCellProps } from "@mui/material";

import withStyles from '@mui/styles/withStyles';

const StickyActionCell = withStyles(() => ({
  head: {
    top: 0,
    right: 0,
    position: "sticky",
    zIndex: 102,
  },
  body: {
    backgroundColor: (props: { index?: number; endScrolled?: boolean; isOneElement?: boolean }) =>
      props?.isOneElement ? "#fff" : (props?.index || 0) % 2 === 0 ? "#f9fafb" : "#FFF",
    minWidth: "50px",
    right: 0,
    top: 0,
    position: "sticky",
    zIndex: 101,
  },
}))(MaterialTableCell);

const stickyImportant = "sticky !important" as "sticky";

const StickyTableCell = withStyles(() => ({
  head: {
    boxShadow: (props: { index?: number; endScrolled?: boolean; isOneElement?: boolean }) =>
      props?.endScrolled ? "" : "-4px 0px 4px 0px rgba(147, 169, 189, 0.2)",
    top: 0,
    right: (props: {
      index?: number;
      endScrolled?: boolean;
      isOneElement?: boolean;
      right?: number;
    }) => (props?.right ? `${props.right}px` : "100px"),
    position: "sticky",
    zIndex: 102,
    transition: "box-shadow 0.3s ease-in-out 0s",
  },
  body: {
    backgroundColor: (props: { index?: number; endScrolled?: boolean; isOneElement?: boolean }) =>
      props?.isOneElement ? "#fff" : (props?.index || 0) % 2 === 0 ? "#f9fafb" : "#FFF",
    minWidth: "50px",
    boxShadow: (props: { index?: number; endScrolled?: boolean }) =>
      props?.endScrolled ? "" : "-4px 0px 4px 0px rgba(147, 169, 189, 0.2)",
    right: (props: {
      index?: number;
      endScrolled?: boolean;
      isOneElement?: boolean;
      right?: number;
    }) => (props?.right ? `${props.right}px` : "100px"),
    top: 0,
    transition: "box-shadow 0.3s ease-in-out 0s",
    position: stickyImportant,
    zIndex: 101,
  },
}))(MaterialTableCell);

interface Props extends TableCellProps {
  sticky?: boolean;
  right?: number;
  index?: number;
  endScrolled?: boolean;
  isOneElement?: boolean;
  isAction?: boolean;
}

const TableCell = (props: Props = {}) => {
  const { sticky = false, right, isAction = false, index, endScrolled, children, isOneElement, ...rest } = props;

  if (sticky && isAction) {
    return (
      <StickyActionCell
        className="sticky-table-cell"
        id="sticky-table-cell"
        index={index}
        isOneElement={isOneElement}
        {...rest}
      >
        {children}
      </StickyActionCell>
    );
  }

  if (sticky) {
    return (
      <StickyTableCell
        className="sticky-table-cell"
        id="sticky-table-cell"
        index={index}
        endScrolled={endScrolled}
        right={right}
        isOneElement={isOneElement}
        {...rest}
      >
        {children}
      </StickyTableCell>
    );
  }

  const { ...materialRest } = rest;

  return <MaterialTableCell {...materialRest}>{children}</MaterialTableCell>;
};

export default TableCell;
